<template>
  <section>


    <b-card no-body class="mt-2"  v-if="items.length !== 0">

      <b-table fixed stacked="md" hover :items="items" :fields="fields">

         <template v-slot:cell(activation.createdDate)="data">
        {{ $moment(data.item.activation.createdDate) | moment("YYYY-MM-DD HH:mm") }}</template>
        
         <template v-slot:cell(activation.isAdmin)="data">
        {{ showAdmin(data.value) }}</template>

        <template v-slot:cell(activation.email)="data">{{data.item.activation.email}}</template>
         <template v-slot:cell(activation.id)="data">

             <b-button size="sm" class="float-right" @click="removeInvite(data.item.activation.id)">
                {{ $t('TEAM.REMOVE_INVITE')}}
              </b-button>
        </template>

      </b-table>
      
    </b-card>
    
    <b-card v-if="items.length === 0" class="mt-2" no-body>
      <b-card-body class="m-4">{{ $t('TEAM.NO_INVITES')}}</b-card-body>
    </b-card>

     <b-pagination
     class="mt-2"
      v-model="currentPage"
      :total-rows="totalItems"
      :per-page="limit"
       align="center"
       @input ="getInvites"
    >
      <template v-slot:first-text>{{$t("PAGINATION.FIRST")}}</template>
      <template v-slot:prev-text>{{$t("PAGINATION.PREV")}}</template>
      <template v-slot:next-text>{{$t("PAGINATION.NEXT")}}</template>
      <template v-slot:last-text>{{$t("PAGINATION.LAST")}}</template>
    </b-pagination>


  </section>
</template>
<script>
//import AddInvite from "@/components/Team/AddInvite";
/*
components: {
    AddInvite
  },
  
*/
export default {
  data() {
    return {
      currentPage: 1,
      limit: 10,
      items: [],
      totalItems: 0,
      fields: [
        {
          key: "activation.createdDate",
          label: this.$t("TEAM.TABLE.CREATED_DATE")
        },
        {
          key: "activation.email",
          label: this.$t("TEAM.TABLE.EMAIL")
        },
        {
          key: "activation.isAdmin",
          label: this.$t("TEAM.TABLE.ADMIN")
        },
        {
          key: "activation.id",
          label: ""
        }
      ],
      user: this.$store.state.auth.user
    };
  },
  methods: {
    invitedResult: function() {
      this.getInvites();
    },
    showState: function(state) {
      if (state === 0) {
        return this.$t("TEAM.ACTIVE");
      }
      return this.$t("TEAM.INACTIVE");
    },
    showAdmin: function(isAdmin) {
      if (isAdmin === 1) {
        return this.$t("YES");
      }
      return this.$t("NO");
    },
    removeInvite: function(activationId) {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/invite/remove", {
          inviteId: activationId
        })
        .then(function() {
          self.getInvites();
        })
        .catch(() => {
          self.$noty.error(self.$t("TEAM.ERROR.COULD_NOT_REMOVE_INVITE"));
        });
    },
    getInvites: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/invite/list", {
          page: this.currentPage,
          limit: this.limit
        })
        .then(response => {
          self.items = response.data.items;
          self.totalItems = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    }
  },
  mounted: function() {
    this.getInvites();
  }
};
</script>
<style>
</style>